"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iBimProjectModels = exports.iBimModel = exports.iRevision = exports.iBimProject = exports.iUploadRevision = exports.iCreate = exports.iBimModelTokens = void 0;
const t = require("io-ts");
exports.iBimModelTokens = t.interface({
    token2d: t.string,
    token3d: t.string,
    modelId: t.string
});
exports.iCreate = t.intersection([
    t.interface({
        projectUuid: t.string,
        revisionUuid: t.string,
        fileName: t.string,
        fileKey: t.string,
    }),
    t.partial({
        bimProject: t.string,
        bimModel: t.string
    })
]);
exports.iUploadRevision = t.interface({
    model: t.string,
    fileName: t.string,
    file: t.any,
    project: t.string
});
exports.iBimProject = t.interface({
    projectId: t.string,
    modelId: t.string,
    fileRevisionUuid: t.string
});
exports.iRevision = t.interface({
    fileRevisionUuid: t.string,
    bimRevisionId: t.string
});
exports.iBimModel = t.intersection([
    t.partial({
        modelId: t.string,
        fileRevisionUuid: t.string,
    }),
    t.partial({
        bimRevisionId: t.string,
        status: t.union([t.literal('SAVED'), t.literal('SAVING'), t.literal('INIT'), t.literal('ERROR'), t.literal('READY')])
    })
]);
exports.iBimProjectModels = t.interface({
    bimProjectId: t.string,
    models: t.array(exports.iBimModel)
});
//# sourceMappingURL=bim.js.map